'use client';
import CustomRichText from '@/components/CustomRichText';
import { SerializedEditorState } from '@payloadcms/richtext-lexical/lexical';
import Image from 'next/image';
import { useState, ReactNode } from 'react';

interface AchievementItemProps {
  achievementItem: {
    titleIcon?: string | { url: string; alt: string };
    title: ReactNode | SerializedEditorState;
    subtitle?: ReactNode | SerializedEditorState;
    hover: ReactNode | SerializedEditorState;
    width?: number;
    height?: number;
  };
  swiperRef: React.RefObject<any>;
}
export default function AchievementItemV2({ achievementItem, swiperRef }: AchievementItemProps) {
  const [isClicked, setIsClicked] = useState(false);
  const handleClick = () => {
    setIsClicked(prev => {
      const newClickedState = !prev;
      if (newClickedState) {
        swiperRef.current.autoplay.stop();
      } else {
        swiperRef.current.autoplay.start();
      }
      return newClickedState;
    });
  };
  return (
    <div
      data-meta="AchievementItemV2"
      className={`achievement-item ${isClicked ? 'clicked' : ''}`}
      onClick={handleClick}
    >
      <div className="achievement-inner">
        <div className="achievement-front">
          {achievementItem.titleIcon && (
            <Image
              src={
                typeof achievementItem.titleIcon === 'string'
                  ? achievementItem.titleIcon
                  : achievementItem.titleIcon.url
              }
              alt={
                typeof achievementItem.titleIcon === 'string' ? '' : achievementItem.titleIcon.alt
              }
              width={achievementItem.width || 45}
              height={achievementItem.height || 45}
              className="object-contain"
            />
          )}
          <CustomRichText
            data={achievementItem.title}
            tag="div"
            className="font-fixel text-center font-bold text-white"
          />
          {achievementItem.subtitle && (
            <CustomRichText
              data={achievementItem.subtitle}
              tag="div"
              className="text-xs p-3 text-white"
            />
          )}
        </div>
        <div className="achievement-back bg-white rounded-full">
          <CustomRichText data={achievementItem.hover} tag="div" className="text-sm" />
        </div>
      </div>
    </div>
  );
}
